import $ from "jquery";
import moment from "moment";
moment.locale("ja");
import { Klass } from "@@assets/scripts/app";
import vuwer from "@pressmedia/vuwer";
import app, { u_ } from "@@assets/scripts/common";


const orders = Klass.new_("TyrellModule", "orders", { app, itemFilter(i, item) {} });
app.orders = orders;

orders.errorCallbacks.INPUT = (messages, methodName, errcode, errtype) => {

	if( u_.isObject(messages) && isNaN(messages.layaway) ) {
		app.alert(messages.layaway);
	}
}

const createOrder = async (code) => {
	const layawayNumber = moment().format('mmss').padStart(4, '0');
	
	const resOrder = await orders._sendRequest("createOrder", {
		type: "POST",
		data: {
			"sheet": "confirm",
			"code": code,
			"dateIssue": moment().format("YYYY-MM-DD HH:mm:ss"),
			"layaway": 'temp' + '-' + layawayNumber,
			"sellState": 0,
			"amount": 0,
			"quantity": 1
		}
	}, (err, res) => {
		if(!err) {
			return res;
		}
	})
	
	return resOrder.response;
};


vuwer.add("layawayPopup", {
	popupKey: "popup-layaway",
	selector: () => $("<div/>"),
	
	onReadyFirst($self) {
		const $main = $("<div/>").addClass("content-main");
		const $layaway = $("<div/>").addClass("layaway");
		
		const $message = $("<div/>").addClass("message").append($("<p/>").html(
			`取り置きのキャンセルは、ホームページ上ではできません。
			キャンセルの場合は花工房ほんまへお問い合わせください。
			`.replace(/\n/g, "<br>").replace(/\t/g, "")
		));

		const $btnClose = $("<button/>").text("取り置きをやめる")
		.addClass("btn-close hover-target").attr({
			type: "button"
		}).on("click", e => {
			e.preventDefault();
			this.hide();
		});
		
		$main.append($layaway, $message, $btnClose )
		$self.append($main);
		this.setProp({ $main ,$layaway });
		
		app.popup.addContent(this.popupKey, $self);
		
		return this;
	},

	onChangeState(state) {
		if(state.item !== this.state.item) {
			
			switch(state.info) {
				case 'confirm': {
					const $layaway = this.$layaway;
			
					if(state.item && u_.isString(state.item)) {
						this.$layaway.empty();
						$layaway.append(state.item);
					} else {
						this.$layaway.empty();
					}
					
					// 取り置きボタン
					const $btnConfirm = this.$layaway.find(".btn-submit");
					$btnConfirm.on("click", async e => {
						e.preventDefault();
						const { value } = e.currentTarget;
						
						const layaway = await createOrder(value);
						
						const isEmpty = Object.keys(layaway).length === 0 && layaway.constructor === Object;
						if( isEmpty ) {
							this.hide();
						} else {
							this.setState({info: 'layaway', layaway: layaway });
						}
						
					});
					break;
				}
					
				case 'layaway': {
					const $main = this.$main.children(".layaway").empty();
					this.$main.children(".message").remove();
					this.$main.children(".btn-close").remove();
					const $layawayBody = $("<div/>").addClass("layaway-body");

					const $note = $("<p/>").addClass("note").html("お客様の「取り置き番号」です。<br>申し込みの際に必要となりますので、手元にお控えください。");
					const $title = $("<p/>").addClass("title").text("取り置き番号");
				
					const $layawayNumber = $("<p/>").addClass("number").text(state.layaway.layaway);
					const $wrapLayaway = $("<div/>").addClass("wrap-layaway").append($layawayNumber);
					
					const $btnSubmit = $("<a/>").attr({href: `./contents/order/${u_.createQueryString(state.layaway)}`}).addClass("submit");
					$btnSubmit.append($("<span/>").text("取り置きした商品の申し込みへ進む"));
					const $wrapMessage = $("<div/>").addClass("message");
					$wrapMessage.append($("<p/>").text("取り置きした商品は、24時間以内にメールまたはFAXでお申し込みください。"));
					$wrapMessage.append($("<p/>").text("24時間以内にお申し込みがない場合、自動的にキャンセルとなります。"));
					$layawayBody.append($note, $title, $wrapLayaway, $btnSubmit, $wrapMessage);
					$main.append($layawayBody);
					break;
				}
			}
		

		}
	},

	async show(mainHTML) {
		await this.setState({info: 'confirm', item: mainHTML });
		await app.popup.showContents(this.popupKey);
		vuwer.get("body").$self.addClass("popup-is-shown");
		return this;
	},
	
	async hide() {
		await app.popup.hideContents(this.popupKey, () => {
			return this.setState({ item: "" });
		});
		
		vuwer.get("body").$self.removeClass("popup-is-shown");
		
		return this;
	},
	
	showConfirm() {
		//const $confirm = this.$main.children(".content-main").remove();
		
	}
});

async function popupLayaway(mainHTML) {
	await vuwer.get("layawayPopup").show(mainHTML);
}

export default popupLayaway;
